import gql from "graphql-tag";

export const GetTaxAddress = gql`
  query GetTaxAddress {
    accounts {
      id
      address {
        city
        id,
        street1,
        state{
          id
        },
        postalCode
      }
    }
  }
`;
